import {Component, Input, OnInit} from '@angular/core';
import {InformationModel, WidgetModel} from '../../../../core/models/widget.model';
import {Router} from '@angular/router';
import {GoogleTagManagerService} from '../../../../core/analytics/google-tag-manager.service';
import {CommunicationProxyService} from '../../../services/communication-proxy.service';
import {CommunicationSubjectEnum} from '../../../enum/communication-subject-enum';
import {ManagerFilterType} from '../../../../home/manager-filters/manager-filters.component';
import {HomeManagerService} from '../../../../home/service/home-manager.service';

@Component({
  selector: 'app-done-visits',
  templateUrl: './done-visits.component.html',
  styleUrls: ['./done-visits.component.scss']
})
export class DoneVisitsComponent implements OnInit {

  @Input() public dragged: boolean;
  @Input() public data: WidgetModel;
  @Input() public info: InformationModel[];
  @Input() public scrolling: boolean;

  constructor(private homeManagerService: HomeManagerService,
              private communicationProxyService: CommunicationProxyService,
              private router: Router,
              private readonly googleTagManagerService: GoogleTagManagerService) { }

  ngOnInit() {
    this.homeManagerService.fetchManagerWidgetData(
        this.data.id,
        { begin: null, end: null, type: ManagerFilterType.Today }
    );
    this.communicationProxyService.subscribe(CommunicationSubjectEnum.onManagerFiltersUpdated, (payload) => {
      this.info = undefined;
      this.homeManagerService.fetchManagerWidgetData(this.data.id, payload.message);
    });
  }

  iconAction() {
    if (this.scrolling) {
      return;
    }

    this.googleTagManagerService.pushTag({
      event: 'event',
      eventCategory: 'crm:home',
      eventAction: 'clique:widgets:visitas-realizadas'
    });

    this.router.navigate([`/facs`]);
  }

}
